import { GetAllRes } from './GetAllRes';

export enum TableColumnKey {
  CodeReferenceName = 'codeReferenceName',
  ReferralCode = 'referralCode',
  ProgramName = 'programName',
  DistributorAgentId = 'distributorAgentId',
  NumberOfUses = 'numberOfUses',
  StartDate = 'startDate',
  EndDate = 'endDate',
  MaximumNumberOfUses = 'maximumNumberOfUses',
  ReferralCodeStatus = 'referralCodeStatus',
  ConsumedSupportedSystem = 'consumedSupportedSystem',
  Source = 'source',
  UsageDetails = 'usageDetails',

  VipLevel = 'vipLevel',
  IdvMethod = 'idvMethod',
  KycLevel = 'kycLevel',

  CreationTime = 'creationTime',
  LastModifiedTime = 'lastModifiedTime',
}

export interface TableRow {
  id: number;

  [TableColumnKey.CodeReferenceName]: string;
  [TableColumnKey.ReferralCode]: string;
  [TableColumnKey.ProgramName]: string;
  [TableColumnKey.DistributorAgentId]: string;
  [TableColumnKey.NumberOfUses]: number;
  [TableColumnKey.StartDate]: null | string;
  [TableColumnKey.EndDate]: string;
  [TableColumnKey.MaximumNumberOfUses]: string | number;
  [TableColumnKey.ReferralCodeStatus]: string;
  [TableColumnKey.ConsumedSupportedSystem]: string;
  [TableColumnKey.Source]: string;

  [TableColumnKey.VipLevel]: number | string;
  [TableColumnKey.IdvMethod]: string;
  [TableColumnKey.KycLevel]: number | string;

  [TableColumnKey.CreationTime]: string;
  [TableColumnKey.LastModifiedTime]: string | undefined;

  rawData: GetAllRes;
}
